import DealerLocationsDataTable from "./DealerLocationDataTable";

export default DealerLocationsDataTable;